import IAction from '@signageos/actions/dist/IAction';

export type AppletConfig = {
	[key: string]: string;
};

export interface IBundledApplet {
	uid: string;
	version: string;
	frontAppletVersion: string | undefined;
	checksum: string;
	binaryFile: string;
	frontAppletBinaryFile: string | undefined;
	config: AppletConfig | undefined;
}

export const NotifyBundledApplet = 'Front.Applet.NotifyBundledApplet';
export interface NotifyBundledApplet extends IAction<typeof NotifyBundledApplet> {
	bundledApplet: IBundledApplet;
}
